import React from 'react';
import { Navigate } from 'react-router-dom';
import jwtUtils from '../utilities/jwtUtils';

const ProtectedRouteContabilidad = ({ element }) => {
  const payload = jwtUtils.getValidRefreshTokenPayload();
  if (!payload) {
    return <Navigate to="/401" replace />;
  }

  if (payload.rol !== 'contabilidad') {
    return <Navigate to="/401" replace />;
  }

  return element;
};

export default ProtectedRouteContabilidad;
